import { Tag } from '@cian/components';
import * as React from 'react';
import { IHouseYearTag } from '../../../state/tags/definitions/house_year';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IHouseYearTagItemProps {
  tag: IHouseYearTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const HouseYearTagItem = ({ withNewTag, onDeleteClick, tag }: IHouseYearTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);
  let text = [];

  if (tag.min !== undefined) {
    text.push(`от ${tag.min}`);
  }

  if (tag.max !== undefined) {
    text.push(`до ${tag.max}`);
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Год постройки {text.join(' ')}
    </TagComponent>
  );
};
